
export default function (key) {
  return new Promise((resolve) => {
    if (window['GoogleMapsInit'] === undefined) {
      console.log("Loading google maps");
      window['GoogleMapsInit'] = resolve;
      let GMap = window.document.createElement('script');
      GMap.async = true;
      GMap.defer = true;
      GMap.setAttribute('src',
        `https://maps.googleapis.com/maps/api/js?key=${key}&callback=GoogleMapsInit&loading=async&libraries=maps,geometry,marker&v=beta`);

      window.document.body.appendChild(GMap);
    }
    else {
      resolve();
    }
  });
}